import React from 'react';
import PropTypes from 'prop-types';

const IconHighlight = ({ icon: Icon, bgColor, iconColor, className = '' }) => (
  <div
    className={[
      'flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0',
      bgColor,
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <Icon size={16} className={iconColor} />
  </div>
);

IconHighlight.propTypes = {
  icon: PropTypes.elementType.isRequired,
  bgColor: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  className: PropTypes.string,
};


export default React.memo(IconHighlight);
